export default __webpack_public_path__ + "static/media/mouse.01941517.svg";